/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useContext, useEffect } from "react";
import { useQuery, useMutation } from "@apollo/client";
import { ITypeEvaluation } from '../../../interfaces/PerformanceEvaluation.interface'
import { AdminContext } from "../../../context/AdminContext/AdminContext";
import PerformanceEvaluationContext from "../../../context/PerformanceEvaluationContext/PerformanceEvaluationContext";
import { openCollaboratoPerformanceEvaluationModal } from "../../../context/PerformanceEvaluationContext/Actions";
import { closePerformanceEvaluationModal } from "../../../context/PerformanceEvaluationContext/Actions";
import {
  GET_ALL_TYPE_EVALUATION,
  CREATE_PERFORMANCE_EVALUATION,
  GET_ALL_PERFORMANCES_EVALUATION
} from "../../../Querys/performanceEvaluation/querys";
import {
  GET_ALL_PROJECT,
  GET_ALL_MODELS_EVALUATION
} from "../../../Querys/querys";
import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  Checkbox,
  ListItemText,
  MenuItem,
  Tooltip,
  makeStyles
} from '@material-ui/core';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DateRangeFieldSV from "../../MyMood/Fields/DateRangeFieldSV";
import { addDays, subMonths, format, isEqual, parseISO } from 'date-fns';
import { ErrorAlert } from "../../../alerts/errorAlert";


const useStyles = makeStyles((theme) => ({
  errorBorder: {
    border: '1px solid #f44336 !important', // Color rojo estándar de error en MUI
    borderRadius: '4px', // Un radio de borde sutil
    '&:hover': {
      borderColor: '#d32f2f !important',
    }
  },
  customTooltip: {
    fontSize: "14px",       
    maxWidth: 500,          
    lineHeight: "1.5",     
    padding: "10px 15px",   
    backgroundColor: "#333" 
  },
  arrow: {
    color: "#333", 
  }
}));

const ModalPerformanceEvaluation = () => {
  const classes = useStyles();
  const { adminState } = useContext(AdminContext)
  const { state, dispatch } = useContext(PerformanceEvaluationContext);
  const [nameModal, setNameModal] = useState("Crear evaluación de desempeño")
  const [projects, setProjects] = useState<Array<any>>([]);
  const [arraytypeEvaluation, setArrayTypeEvaluation] = useState<ITypeEvaluation[]>([]);
  const [selectedAllProjects, setSelectedAllProjects] = useState<String[]>([]);
  const [modelsEvaluation, setModelsEvalution] = useState<Array<any>>([]);
  const [stateCalendario, setStateCalendario] = useState([
    {
      startDate: subMonths(new Date(), 0),
      endDate: addDays(new Date(), 0),
      key: "selection"
    }]
  );
  const [startDate, setStartDate] = useState(subMonths(new Date(), 0).toString());
  const [endDate, setEndDate] = useState(addDays(new Date(), 0).toString());
  const [counterTxt, setCounterTxt] = useState(0);
  const [inputPctAutoDisabled, setInputPctAutoDisabled] = useState(true);
  const [inputPctLiderDisabled, setInputPctLiderDisabled] = useState(true);
  const [inputPctColegaDisabled, setInputPctColegaDisabled] = useState(true);
  const [inputPctSubordinadosDisabled, setInputPctSubordinadosDisabled] = useState(true);
  const [inputPctClienteDisabled, setInputPctClienteDisabled] = useState(true);
  const [errorPeriod] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [initialValuesForm, setInitialValuesForm] = useState(
    {
      nameEvaluation: "",
      areas: [],
      typeEvaluation: "",
      pctAutoevaluacion: "Peso de evaluación *",
      pctLider: "Peso de evaluación *",
      pctColegas: "Peso de evaluación *",
      pctSubordinados: "Peso de evaluación *",
      pctClientes: "Peso de evaluación *",
      modelEvaluation:"",      
      inptDateClose:"" ,
      descripcion:"",
      periodo: stateCalendario
    }
  );

  const { data: resultProject, startPolling: projectStartPoll, stopPolling: projectStopPoll } = useQuery(GET_ALL_PROJECT);
  const allProject = resultProject?.GET_ALL_PROJECT;
  const { data: typeEvaluation } = useQuery(GET_ALL_TYPE_EVALUATION, {
    variables: { idCompany: adminState?.idEnterprise },
    fetchPolicy: 'no-cache'
  });

  const arrayTypeEvaluation = typeEvaluation?.GET_ALL_TYPE_EVALUATION;

  const { data: resultModels, startPolling, stopPolling } = useQuery(GET_ALL_MODELS_EVALUATION)
  const allModels = resultModels?.GET_ALL_MODELS_EVALUATION

  const [createPerformanceEvaluation] = useMutation(CREATE_PERFORMANCE_EVALUATION, {
    refetchQueries: [
      { query: GET_ALL_PERFORMANCES_EVALUATION }
    ],
  });

  useEffect(() => {
    if (state.item !== null) {
      setNameModal("Duplicar evaluación de desempeño")
      const dateClose = state.item.inptDateClose.split('T')
      const arrayAreas: any = [];
      state.item.areas.map((area: any) => {
        arrayAreas.push(area.area)
      })   
  setSelectedAllProjects(arrayAreas)  
  setCounterTxt(state.item.description.length)
  const newInfoEval={
    nameEvaluation:state.item.namePerformance,     
    areas: arrayAreas,
    typeEvaluation: state.item.idTypeEvaluation,
    pctAutoevaluacion:`${state.item.pctAutoevaluacion} %`,
    pctLider:`${state.item.pctLider} %`,
    pctColegas: `${state.item.pctColegas} %`,
    pctSubordinados:`${state.item.pctSubordinados} %`,
    pctClientes:`${state.item.pctClientes} %`, 
    modelEvaluation:state.item.modelEvaluation,      
    inptDateClose:dateClose[0].toString(),
    descripcion:state.item.description,
    periodo: [ 
       {
         startDate: addDays(new Date(state.item.DateInit), 1),
         endDate: addDays(new Date(state.item.DateEnd), 1),
         key: "selection"
       }
    ]
  }
  handleChangeTypeEvaluation(state.item.idTypeEvaluation)
  setStateCalendario([
     {
       startDate: addDays(new Date(state.item.DateInit), 1),
       endDate: addDays(new Date(state.item.DateEnd), 1),
       key: "selection"
     }]);
    setStartDate(addDays(new Date(state.item.DateInit), 1).toString())
    setEndDate(addDays(new Date(state.item.DateEnd), 0).toString());  
    setInitialValuesForm(newInfoEval)  
 }else{
  setNameModal("Crear evaluación de desempeño")
  setStateCalendario([
    {
      startDate: subMonths(new Date(), 0),
      endDate: addDays(new Date(), 0),
      key: "selection"
    }]
  );
  setStartDate(subMonths(new Date(), 0).toString());
  setEndDate (addDays(new Date(), 0).toString());    
 }
},[state])

  useEffect(() => {
    startPolling(3000);
    return () => {
      stopPolling()
    }
  }, [startPolling, stopPolling])

  useEffect(() => {
    projectStartPoll(3000);
    return () => {
      projectStopPoll()
    }
  }, [projectStartPoll, projectStopPoll])

  useEffect(() => {
    if (allProject) {
      setProjects(allProject)
    }
  }, [allProject]);

  useEffect(() => { if (arrayTypeEvaluation) setArrayTypeEvaluation(arrayTypeEvaluation) }, [arrayTypeEvaluation]);

  useEffect(() => {
    if (allModels) {
      setModelsEvalution(allModels)
    }
  }, [allModels]);

  const handleChangeTypeEvaluation = (typeEval: any) => {
    switch (parseInt(typeEval)) {
      case 1:
        setInputPctAutoDisabled(false)
        setInputPctLiderDisabled(false)
        setInputPctColegaDisabled(true)
        setInputPctSubordinadosDisabled(true)
        setInputPctClienteDisabled(true)
        formik.setFieldValue("pctAutoevaluacion", `${0} %`);
        formik.setFieldValue("pctLider", `${0} %`);
        formik.setFieldValue("pctColegas", "Peso de evaluación *");
        formik.setFieldValue("pctSubordinados", "Peso de evaluación *");
        formik.setFieldValue("pctClientes", "Peso de evaluación *");
        break;
      case 2:
        setInputPctAutoDisabled(false)
        setInputPctLiderDisabled(false)
        setInputPctColegaDisabled(false)
        setInputPctSubordinadosDisabled(true)
        setInputPctClienteDisabled(true)
        formik.setFieldValue("pctAutoevaluacion", `${0} %`);
        formik.setFieldValue("pctLider", `${0} %`);
        formik.setFieldValue("pctColegas", `${0} %`);
        formik.setFieldValue("pctSubordinados", "Peso de evaluación *");
        formik.setFieldValue("pctClientes", "Peso de evaluación *");
        break;
      case 3:
        setInputPctAutoDisabled(false)
        setInputPctLiderDisabled(false)
        setInputPctColegaDisabled(false)
        setInputPctSubordinadosDisabled(false)
        setInputPctClienteDisabled(true)
        formik.setFieldValue("pctAutoevaluacion", `${0} %`);
        formik.setFieldValue("pctLider", `${0} %`);
        formik.setFieldValue("pctColegas", `${0} %`);
        formik.setFieldValue("pctSubordinados", `${0} %`);
        formik.setFieldValue("pctClientes", "Peso de evaluación *");
        break;
      case 4:
        setInputPctAutoDisabled(false)
        setInputPctLiderDisabled(false)
        setInputPctColegaDisabled(false)
        setInputPctSubordinadosDisabled(false)
        setInputPctClienteDisabled(false)
        formik.setFieldValue("pctAutoevaluacion", `${0} %`);
        formik.setFieldValue("pctLider", `${0} %`);
        formik.setFieldValue("pctColegas", `${0} %`);
        formik.setFieldValue("pctSubordinados", `${0} %`);
        formik.setFieldValue("pctClientes", `${0} %`);
        break;
    }
  }

  const handleSetFormat = (type: string) => {
    let val
    let cleanVal
    let valueFloat
    let valPor
    switch (type) {
      case "pctAutoevaluacion":
        val = formik.values.pctAutoevaluacion
        cleanVal = val.replace("%", "").replaceAll(",", "")
        valueFloat = parseFloat(cleanVal)
        valPor = isNaN(valueFloat) ? '0 %' : `${valueFloat} %`;
        formik.setFieldValue("pctAutoevaluacion", valPor);
        break;
      case "pctLider":
        val = formik.values.pctLider
        cleanVal = val.replace("%", "").replaceAll(",", "")
        valueFloat = parseFloat(cleanVal)
        valPor = isNaN(valueFloat) ? '0 %' : `${valueFloat} %`;
        formik.setFieldValue("pctLider", valPor);
        break;
      case "pctColegas":
        val = formik.values.pctColegas
        cleanVal = val.replace("%", "").replaceAll(",", "")
        valueFloat = parseFloat(cleanVal)
        valPor = isNaN(valueFloat) ? '0 %' : `${valueFloat} %`;
        formik.setFieldValue("pctColegas", valPor);
        break;
      case "pctSubordinados":
        val = formik.values.pctSubordinados
        cleanVal = val.replace("%", "").replaceAll(",", "")
        valueFloat = parseFloat(cleanVal)
        valPor = isNaN(valueFloat) ? '0 %' : `${valueFloat} %`;
        formik.setFieldValue("pctSubordinados", valPor);
        break;
      case "pctClientes":
        val = formik.values.pctClientes
        cleanVal = val.replace("%", "").replaceAll(",", "")
        valueFloat = parseFloat(cleanVal)
        valPor = isNaN(valueFloat) ? '0 %' : `${valueFloat} %`;
        formik.setFieldValue("pctClientes", valPor);
        break;
    }
  }

  const cleanVal = (val: any) => {
    return val.replace("%", "").replaceAll(",", "")
  }

  const handlePctTypeEval = (namefield: string, val: any) => {
    const fields = ['pctAutoevaluacion', 'pctLider', 'pctColegas', 'pctSubordinados', 'pctClientes']
    const valClean = cleanVal(val)
    if (valClean > 100) {
      ErrorAlert({ text: 'El porcentaje no puede ser mayor de 100%' });
      fields.forEach((field, index) => {
        if (field === namefield) {
          return formik.setFieldValue(fields[index], `${0} %`);
        }
      })
    }
  }

  const sumPct = (arrayValues: any) => {
    const sumaTotal = arrayValues.reduce((total: any, numero: any) => {
      return total + numero;
    }, 0);
    return sumaTotal
  }

  const vlaPct = () => {
    const typeEval = parseInt(formik.values.typeEvaluation)
    let arrayPcts: any = []

    switch (typeEval) {
      case 1:
        arrayPcts.push(parseInt(formik.values.pctAutoevaluacion), parseInt(formik.values.pctLider))
        return sumPct(arrayPcts)

      case 2:
        arrayPcts.push(parseInt(formik.values.pctAutoevaluacion), parseInt(formik.values.pctLider), parseInt(formik.values.pctColegas))
        return sumPct(arrayPcts)

      case 3:
        arrayPcts.push(parseInt(formik.values.pctAutoevaluacion), parseInt(formik.values.pctLider), parseInt(formik.values.pctColegas), parseInt(formik.values.pctSubordinados))
        return sumPct(arrayPcts)

      case 4:
        arrayPcts.push(parseInt(formik.values.pctAutoevaluacion), parseInt(formik.values.pctLider), parseInt(formik.values.pctColegas), parseInt(formik.values.pctSubordinados), parseInt(formik.values.pctClientes))
        return sumPct(arrayPcts)

    }

  }

  const onChangeProject = (e: any) => {
    let newValues = [];
    if (e.target.value.indexOf('Todas') > -1) {
      if (projects.length === selectedAllProjects.length) {
        newValues = [];
      } else {
        newValues = projects.map((item: any) => item.proyectName);
      }
    } else {
      newValues = e.target.value;
    }
    setSelectedAllProjects(newValues);

    formik.setFieldValue('areas', newValues);

    formik.setFieldTouched('areas', true);
  }

  const counterArea = (e: any) => {
    setCounterTxt(e.length)
  }

  const closeModalPerEv = () => {
    setSelectedAllProjects([]);
    setInputPctAutoDisabled(true)
    setInputPctLiderDisabled(true)
    setInputPctColegaDisabled(true)
    setInputPctSubordinadosDisabled(true)
    setInputPctClienteDisabled(true)
    setCounterTxt(0)
    setInitialValuesForm(
      {
        nameEvaluation: "",
        areas: [],
        typeEvaluation: "",
        pctAutoevaluacion: "Peso de evaluación *",
        pctLider: "Peso de evaluación *",
        pctColegas: "Peso de evaluación *",
        pctSubordinados: "Peso de evaluación *",
        pctClientes: "Peso de evaluación *",
        modelEvaluation:"",      
        inptDateClose:"" ,
        descripcion:"",
        periodo: stateCalendario
      }
    );
    formik.resetForm();
    closePerformanceEvaluationModal("", null, false, dispatch)
  }

    const validationSchema = () => {
  return {
    nameEvaluation: Yup.string().required("Obligatorio"),
    areas: Yup.array().min(1, "Obligatorio").required("Obligatorio"), 
    typeEvaluation: Yup.string().required("Obligatorio"),
    modelEvaluation: Yup.string().required("Obligatorio"),
    inptDateClose: Yup.date().required('Obligatorio'),
    periodo: Yup.array().test('fechas-diferentes', 'Rango no valido', (value) => {
      if (!value || value.length === 0) return false;
      const startDate = value[0].startDate;
      const endDate = value[0].endDate;
      const start = format(new Date(startDate), 'yyyy-MM-dd');
      const end = format(new Date(endDate), 'yyyy-MM-dd');
      return start !== end;
    }),
  }
}

  const formik = useFormik({
    initialValues: initialValuesForm,
    enableReinitialize: true,
    validationSchema: Yup.object(validationSchema()),
    onSubmit: async (formData, { resetForm }) => {
      const nameEvaluation = formData.nameEvaluation.trim()
      const initDate: any = format(stateCalendario[0].startDate, 'yyyy-MM-dd')
      const endDate: any = format(stateCalendario[0].endDate, 'yyyy-MM-dd')
      const dateEqual = isEqual(parseISO(initDate), parseISO(endDate))
      const res = vlaPct();
      if (res < 100) {
        return ErrorAlert({ text: 'La sumatoria de los porcentajes no puede ser menor que el 100%' });
      }

      if (res > 100) {
        return ErrorAlert({ text: 'La sumatoria de los porcentajes no puede ser mayor que el 100%' });
      }

      if (dateEqual) {
        return ErrorAlert({ text: 'Necesita seleccionar un rango de fechas' });
      }
      if (selectedAllProjects.length === 0) {
        return ErrorAlert({ text: 'Es necesario seleccionar un área o proyecto.' });
      }
      let variablesPerformanceEvaluation
      switch (parseInt(formData.typeEvaluation)) {
        case 1:
          variablesPerformanceEvaluation = {
            ...formData,
            nameEvaluation: nameEvaluation,
            areas: selectedAllProjects,
            typeEvaluation: parseInt(formData.typeEvaluation),
            pctAutoevaluacion: parseInt(cleanVal(formData.pctAutoevaluacion)),
            pctLider: parseInt(cleanVal(formData.pctLider)),
            pctColegas: 0,
            pctSubordinados: 0,
            pctClientes: 0,
            startPerformance: initDate,
            endPerformance: endDate,
            idAdmin: adminState?.id,
            idCompany: adminState?.idEnterprise
          }
          break;
        case 2:
          variablesPerformanceEvaluation = {
            ...formData,
            nameEvaluation: nameEvaluation,
            areas: selectedAllProjects,
            typeEvaluation: parseInt(formData.typeEvaluation),
            pctAutoevaluacion: parseInt(cleanVal(formData.pctAutoevaluacion)),
            pctLider: parseInt(cleanVal(formData.pctLider)),
            pctColegas: parseInt(cleanVal(formData.pctColegas)),
            pctSubordinados: 0,
            pctClientes: 0,
            startPerformance: initDate,
            endPerformance: endDate,
            idAdmin: adminState?.id,
            idCompany: adminState?.idEnterprise
          }
          break;
        case 3:
          variablesPerformanceEvaluation = {
            ...formData,
            nameEvaluation: nameEvaluation,
            areas: selectedAllProjects,
            typeEvaluation: parseInt(formData.typeEvaluation),
            pctAutoevaluacion: parseInt(cleanVal(formData.pctAutoevaluacion)),
            pctLider: parseInt(cleanVal(formData.pctLider)),
            pctColegas: parseInt(cleanVal(formData.pctColegas)),
            pctSubordinados: parseInt(cleanVal(formData.pctSubordinados)),
            pctClientes: 0,
            startPerformance: initDate,
            endPerformance: endDate,
            idAdmin: adminState?.id,
            idCompany: adminState?.idEnterprise
          }
          break;
        case 4:
          variablesPerformanceEvaluation = {
            ...formData,
            nameEvaluation: nameEvaluation,
            areas: selectedAllProjects,
            typeEvaluation: parseInt(formData.typeEvaluation),
            pctAutoevaluacion: parseInt(cleanVal(formData.pctAutoevaluacion)),
            pctLider: parseInt(cleanVal(formData.pctLider)),
            pctColegas: parseInt(cleanVal(formData.pctColegas)),
            pctSubordinados: parseInt(cleanVal(formData.pctSubordinados)),
            pctClientes: parseInt(cleanVal(formData.pctClientes)),
            startPerformance: initDate,
            endPerformance: endDate,
            idAdmin: adminState?.id,
            idCompany: adminState?.idEnterprise
          }
          break;
      }
      try {
        setButtonDisabled(true)
        const resCreate = await createPerformanceEvaluation({
          variables: {
            input: variablesPerformanceEvaluation,
          },
        });
        setButtonDisabled(false)
        closeModalPerEv()
        const idPerEVal = resCreate?.data?.CREATE_PERFORMANCE_EVALUATION
        openCollaboratoPerformanceEvaluationModal(idPerEVal.toString(), true, true, dispatch)
      }
      catch (e) {
        ErrorAlert({ text: 'Ocurrió un error al crear la evaluación' });
        console.log("error", e)
        setButtonDisabled(false)
      }
    }
  });

   useEffect(() => {
    formik.setFieldValue('periodo', stateCalendario);
}, [stateCalendario]);    

const getEvaluationDescription = (id: number) => {
    switch (parseInt(id.toString())) {
      case 1: // 90°
        return "Participan: Autoevaluación y Líder.";
      case 2: // 180°
        return "Participan: Autoevaluación, Líder y Colega.";
      case 3: // 270°
        return "Participan: Autoevaluación, Líder, Colega y Subordinados.";
      case 4: // 360°
        return "Participan: Autoevaluación, Líder, Colega, Subordinados y Cliente.";
      default:
        return "";
    }
  };

  return (
    <>
      <Dialog
        open={state.modalPerformanceEvaluation}
        aria-labelledby="form-dialog-title"
        className="dialogPrestacion"
      >
        <IconButton aria-label="close" onClick={(() => { closeModalPerEv() })}
          sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500], }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent  >
          <Form
            className="containerMdalPerformanceEval"
            onSubmit={formik.handleSubmit}
          >
            <DialogTitle className="titleModalPerformanceEval" ><span className="txtTitleModalPerformanceEval">{nameModal}</span></DialogTitle>

            <DialogContent className="oneComponentPerformanceEvaluation">
              <TextField
                type="text"
                name="nameEvaluation"
                label="Nombre de la evaluación*"
                variant="outlined"
                size="small"
                fullWidth={true}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                inputProps={{ maxLength: 50 }}
                value={formik.values.nameEvaluation}
                onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                error={formik.touched.nameEvaluation && Boolean(formik.errors.nameEvaluation)}
                helperText={formik.touched.nameEvaluation && formik.errors.nameEvaluation}
              />
            </DialogContent>
            <DialogContent className="oneComponentPerformanceEvaluation">
              <FormControl
                fullWidth
                size="small"
                variant="outlined"
                className="question"
                error={formik.touched.areas && Boolean(formik.errors.areas)}
              >
                <InputLabel id="demo-simple-select-label"
                  style={{ backgroundColor: "#FFFFFF" }}
                >&Aacute;rea  o Proyecto *</InputLabel>
                <Select
                  style={{
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    width: "100%",
                    height: "40px"
                  }}
                  value={selectedAllProjects}
                  onChange={
                    (e) => {
                      onChangeProject(e);
                    }
                  }
                  labelId="demo-simple-select-label"
                  id="areas"
                  name="areas"
                  multiple
                  renderValue={(selected: any) => selected.join(',')}
                  error={formik.touched.areas && Boolean(formik.errors.areas)}
                >
                  <MenuItem key={0} value={'Todas'}>
                    <Checkbox
                      checked={selectedAllProjects.length === projects.length}
                      style={{
                        color: "#FABB00",
                      }}
                    />
                    <ListItemText primary={"Todas"} />
                  </MenuItem>
                  {
                    projects.map((project: any) => (
                      <MenuItem key={project.id} value={project.proyectName}>
                        <Checkbox checked={selectedAllProjects.indexOf(project.proyectName) > -1} style={{
                          color: "#FABB00",
                        }} />
                        <ListItemText primary={project.proyectNameAndClient} />
                      </MenuItem>
                    ))
                  }
                </Select>
                <FormHelperText style={{ color: "red" }}>
                  {formik.touched.areas && formik.errors.areas}
                </FormHelperText>
              </FormControl>
            </DialogContent>
            <DialogContent className="oneComponentPerformanceEvaluation">
              <FormControl
                fullWidth
                size="small"
                variant="outlined">
                <InputLabel id="demo-customized-select-label" style={{ backgroundColor: "#FFFFFF" }}>Tipo de evaluación *</InputLabel>
                <Select
                  style={{
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    width: "100%",
                    height: "40px"
                  }}
                  labelId="demo-simple-select-label"
                  id="typeEvaluation"
                  name="typeEvaluation"
                  value={formik.values.typeEvaluation ?? ''}
                  onChange={(e) => {
                    formik.handleChange(e);
                    handleChangeTypeEvaluation(e.target.value)
                  }}
                  error={formik.touched.typeEvaluation && Boolean(formik.errors.typeEvaluation)}
                >
                  {arraytypeEvaluation.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      <Tooltip
                        title={getEvaluationDescription(option.id)}
                        placement="right"
                        arrow
                        classes={{ tooltip: classes.customTooltip, arrow: classes.arrow }}
                      >
                        <div style={{ width: '100%' }}>
                          {option.name}
                        </div>
                      </Tooltip>
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText style={{ color: "red" }}>
                  {formik.touched.typeEvaluation && formik.errors.typeEvaluation}
                </FormHelperText>
              </FormControl>
            </DialogContent>
            <DialogContent className="twoComponent">
              <div><label className="lblPerformanceEval">Autoevaluación</label></div>
              <TextField
                type="text"
                name="pctAutoevaluacion"
                variant="outlined"
                size="small"
                disabled={inputPctAutoDisabled}
                onBlur={(e) => {
                  handleSetFormat("pctAutoevaluacion");
                }}
                onChange={(e) => {
                  formik.handleChange(e);
                  handlePctTypeEval('pctAutoevaluacion', e.target.value);
                }
                }
                onKeyPress={(event: any) => {
                  if (!/^[0-9]+$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                error={formik.touched.pctAutoevaluacion && Boolean(formik.errors.pctAutoevaluacion)}
                helperText={formik.touched.pctAutoevaluacion && formik.errors.pctAutoevaluacion}
                value={formik.values.pctAutoevaluacion}
                inputProps={{
                  maxLength: 5,
                  style: {
                    width: "180px",
                  },
                }}
                InputLabelProps={{ style: { fontSize: 12 } }}
              />
            </DialogContent>
            <DialogContent className="twoComponent">
              <div><label className="lblPerformanceEval">Líder</label></div>
              <TextField
                type="text"
                name="pctLider"
                variant="outlined"
                size="small"
                onChange={(e) => {
                  formik.handleChange(e);
                  handlePctTypeEval('pctLider', e.target.value);
                }}
                onBlur={(e) => {
                  handleSetFormat("pctLider");
                }}
                onKeyPress={(event: any) => {
                  if (!/^[0-9]+$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                disabled={inputPctLiderDisabled}
                error={formik.touched.pctLider && Boolean(formik.errors.pctLider)}
                helperText={formik.touched.pctLider && formik.errors.pctLider}
                value={formik.values.pctLider}
                inputProps={{
                  maxLength: 5,
                  style: {
                    width: "180px",
                  },
                }}
                InputLabelProps={{ style: { fontSize: 12 } }}
              />
            </DialogContent>
            <DialogContent className="twoComponent">
              <div><label className="lblPerformanceEval">Colegas</label></div>
              <TextField
                type="text"
                name="pctColegas"
                variant="outlined"
                size="small"
                disabled={inputPctColegaDisabled}
                onChange={(e) => {
                  formik.handleChange(e);
                  handlePctTypeEval('pctColegas', e.target.value);
                }}
                onBlur={(e) => {
                  handleSetFormat("pctColegas");
                }}
                onKeyPress={(event: any) => {
                  if (!/^[0-9]+$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                error={formik.touched.pctColegas && Boolean(formik.errors.pctColegas)}
                helperText={formik.touched.pctColegas && formik.errors.pctColegas}
                value={formik.values.pctColegas}
                inputProps={{
                  maxLength: 5,
                  style: {
                    width: "180px",
                  },
                }}
                InputLabelProps={{ style: { fontSize: 12 } }}
              />
            </DialogContent>
            <DialogContent className="twoComponent">
              <div><label className="lblPerformanceEval">Subordinados </label></div>
              <TextField
                type="text"
                name="pctSubordinados"
                variant="outlined"
                size="small"
                disabled={inputPctSubordinadosDisabled}
                onChange={(e) => {
                  formik.handleChange(e);
                  handlePctTypeEval('pctSubordinados', e.target.value);
                }}
                onBlur={(e) => {
                  handleSetFormat("pctSubordinados");
                }}
                onKeyPress={(event: any) => {
                  if (!/^[0-9]+$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                error={formik.touched.pctSubordinados && Boolean(formik.errors.pctSubordinados)}
                helperText={formik.touched.pctSubordinados && formik.errors.pctSubordinados}
                value={formik.values.pctSubordinados}
                inputProps={{
                  maxLength: 5,
                  style: {
                    width: "180px",
                  },
                }}
                InputLabelProps={{ style: { fontSize: 12 } }}
              />
            </DialogContent>
            <DialogContent className="twoComponent">
              <div><label className="lblPerformanceEval">Cliente </label></div>
              <TextField
                type="text"
                name="pctClientes"
                variant="outlined"
                size="small"
                disabled={inputPctClienteDisabled}
                onChange={(e) => {
                  formik.handleChange(e);
                  handlePctTypeEval('pctClientes', e.target.value);
                }}
                onBlur={(e) => {
                  handleSetFormat("pctClientes");
                }}
                onKeyPress={(event: any) => {
                  if (!/^[0-9]+$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                error={formik.touched.pctClientes && Boolean(formik.errors.pctClientes)}
                helperText={formik.touched.pctClientes && formik.errors.pctClientes}
                value={formik.values.pctClientes}
                inputProps={{
                  maxLength: 5,
                  style: {
                    width: "180px",
                  },
                }}
                InputLabelProps={{ style: { fontSize: 12 } }}
              />
            </DialogContent>
            <DialogContent className="oneComponentPerformanceEvaluation">
              <FormControl
                fullWidth
                size="small"
                variant="outlined">
                <InputLabel id="demo-customized-select-label" style={{ backgroundColor: "#FFFFFF" }}>Modelo de evaluación *</InputLabel>
                <Select
                  style={{
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    width: "100%",
                    height: "40px"
                  }}
                  labelId="demo-simple-select-label"
                  id="modelEvaluation"
                  name="modelEvaluation"
                  value={formik.values.modelEvaluation ?? ''}
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                  error={formik.touched.modelEvaluation && Boolean(formik.errors.modelEvaluation)}
                >
                  {modelsEvaluation.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.name}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText style={{ color: "red" }}>
                  {formik.touched.modelEvaluation && formik.errors.modelEvaluation}
                </FormHelperText>
              </FormControl>
            </DialogContent>
            <DialogContent className="twoComponent">
              <div>
                <DateRangeFieldSV
                  setDate={setStateCalendario}
                  containerClass={`fieldsetInputPerformanceEvaluation ${formik.touched.periodo && formik.errors.periodo ? classes.errorBorder : ""
                  }`}
                  daySelected1={startDate}
                  daySelected2={endDate}
                  nameLabel={"Periodo"} 
                                   
                  />    
           {formik.touched.periodo && formik.errors.periodo ? (
                  <FormHelperText style={{ color: "red", marginLeft: "14px" }}>
                    {formik.errors.periodo as string}
                  </FormHelperText>
                ): null}
            </div>
            <div className="dateClose">
            <TextField              
                  variant="outlined"
                  size="small"
                  type="date"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  label="Fecha de cierre *"
                  name="inptDateClose"
                  inputProps={{
                    readOnly: false,
                    style: {
                      width: "200px",
                      height: "22px",
                    },
                  }}
                  onChange={formik.handleChange}
                  error={formik.touched.inptDateClose && Boolean(formik.errors.inptDateClose)}
                  helperText={formik.touched.inptDateClose && formik.errors.inptDateClose}
                  value={formik.values.inptDateClose}
                />
              </div>
            </DialogContent>

            <DialogContent className="oneComponentPerformanceEvaluation">
              <TextField
                id="outlined-multiline-static"
                label="Descripción"
                multiline
                value={formik.values.descripcion}
                name="descripcion"
                onBlur={formik.handleBlur}
                onChange={(e: any) => {
                  formik.handleChange(e);
                  counterArea(e.target.value);
                }}
                rows={3}
                style={{ width: 465, fontFamily: 'Roboto', fontStyle: 'italic' }}
                variant="outlined"
                inputProps={{ maxLength: 150 }}
              />
              <div className="divCounterArea"><label className="txtConterPres">{`${counterTxt}/150`}</label></div>
            </DialogContent>
            <DialogContent className="twoComponentBtns">
              <div className="containerButtons">
                <div className="containerCancelPreestacion">
                  <button className="btnCancelPrestacion" type="button"
                    onClick={(() => {
                      //  formik.resetForm();
                      closeModalPerEv();
                    }
                    )}>
                    Cancelar
                  </button>
                </div>
                <div className="containerAddPrestacion">
                  <button className="btnAddPrestacion" type="submit" disabled={buttonDisabled}>
                    <div className="infobtnAddRestriccion">
                      <div><span className="txtBtnAdd">Continuar</span> </div>
                    </div>
                  </button>
                </div>
              </div>
            </DialogContent>
          </Form>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default ModalPerformanceEvaluation

